import mock from '../../mockAdapter';
import { recategorizeData, categoriesImages } from '@/types/apps/EcommerceType';
import otrosImage from '/images/product_categories/OTROS.png';

// third-party
import { add, sub } from 'date-fns';
import { Chance } from 'chance';
import product1 from '/images/products/s10.jpg';
import product2 from '/images/products/s10.jpg';
import product3 from '/images/products/s10.jpg';
import product4 from '/images/products/s10.jpg';
import product5 from '/images/products/s10.jpg';
import product6 from '/images/products/s10.jpg';
import product7 from '/images/products/s10.jpg';
import product8 from '/images/products/s10.jpg';

//Types
import type { Products } from '@/types/apps/EcommerceType';

const chance = new Chance();
// products list
const products: Products[] = [
	{
		id : 1430,
		image: "https:\/\/www.dropbox.com\/scl\/fi\/8qolzbpd5l3l4c8ju554k\/00184489.jpg?raw=1&rlkey=3wk5y9aeh182nd1krmzn54mgf",
		name: "GARBANZO EURO 500gr",
		description: "GARBANZO EURO  x 500GR",
		price: 3750.0,
		categories: ["GRANOS"],
		stock: 0,
		discount: 0.0
	},
	{
		id : 1431,
		name: "GARBANZO EURO 500gr",
		description: "GARBANZO EURO  x 500GR",
		price: 3750.0,
		categories: ["GRANOS"],
		stock: 7,
		discount: 0.0
	},
	{
		id : 2402,
		name: "PANDEQUESO",
		description: "PANDEQUESO EURO",
		price: 2900.0,
		categories: ["PANADERIA FRESCA"],
		stock: 9,
		discount: 0.0
	}];

// ==============================|| MOCK SERVICES ||============================== //

// mock.onGet('/api/products/list').reply(200, { products });
mock.onGet('/api/products/list').reply((config: any) => {
    const { page = 1, pageSize = 10, filters = [], ordering = null, search = null } = config.params;

    const pageNumber = parseInt(page, 10);
    const pageSizeNumber = parseInt(pageSize, 10);
    const startIndex = (pageNumber - 1) * pageSizeNumber;
    const endIndex = startIndex + pageSizeNumber;

    var filteredProducts = products;

    for (const item of products) {
        const findCategory = recategorizeData.find(data => data.category === item.categories[0])
        const newCategory = findCategory && findCategory.group ? findCategory.group : item.categories[0]
        const findImage = categoriesImages.find(data => data.category === newCategory)
        const categoryImage = findImage && findImage.image ? findImage.image : otrosImage
        item.image = item.image ? item.image : categoryImage
        item.categoryImage = categoryImage;
        item.categories = [newCategory]
    }

    if (filters.length > 0){
        filteredProducts = products.filter(product => {
            return filters.every((filter:any) => {
                if (filter.type === 'category') {
                    return filter.value.split(',').some((category:any) => product.categories.includes(category));
                } else if (filter.type === 'price') {
                    const priceFilter = filter.value.split(':');
                    return product.price && product.price >= parseInt(priceFilter[0]) && product.price <= parseInt(priceFilter[1]);
                } else if (filter.type === 'discount') {
                    return filter.value ? product.discount : !product.discount;
                }  else if (filter.type === 'stock') {
                    return filter.value ? product.stock ?? 0 > 0 : product.stock == 0;
                }
                return true;
            });
        });
    }
    if (ordering){
        filteredProducts = filteredProducts.sort((a, b) => {
            if (ordering === 'price') {
                return a.price - b.price;
            } else if (ordering === '-price') {
                return b.price - a.price;
            } else if (ordering === 'discount') {
                return a.discount - b.discount;
            } else if (ordering === '-discount') {
                return b.discount - a.discount;
            } else if (ordering === 'stock') {
                return a.stock - b.stock;
            } else if (ordering === '-stock') {
                return b.stock - a.stock;
            }
            return 0;
        });
    }
    if (search){
        filteredProducts = filteredProducts.filter(product => 
            product.name.toLowerCase().includes(search.toLowerCase()) ||
            product.description?.toLowerCase().includes(search.toLowerCase())
            // # TODO: Consulta por EAN
        );
    }
    const paginatedData = filteredProducts.slice(startIndex, endIndex);
    const totalRecords = filteredProducts.length;
    return [
        200,
        {
            results: paginatedData,
            count: totalRecords,
            currentPage: pageNumber,
            totalPages: Math.round(totalRecords / pageSizeNumber),
            pageSize: pageSizeNumber
        },
    ];
});

mock.onGet('/api/categories/list').reply(() => {
    const categories = Array.from(new Set(recategorizeData.flatMap(product => product.group))).flat().sort();
    return [
        200,
        {
            results: categories,
            count: categories.length
        },
    ];
});

export default products;

